// extracted by mini-css-extract-plugin
module.exports = {"information":"Information_information__Tdq8Y","informationName":"Information_informationName__oLvz3","informationTitle":"Information_informationTitle__aHcux"};